import React from "react";
import { clsx } from "clsx";

export interface FormFieldProps {
    id: string;
    label: string;
    required?: boolean;
    description?: string;
    error?: string;
    children: React.ReactNode;
    className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
    id,
    label,
    required,
    description,
    error,
    children,
    className,
}) => (
    <div className={clsx("flex flex-col gap-1.5", className)}>
        <label htmlFor={id} className="text-sm font-medium text-neutral-dark dark:text-white">
            {label}
            {required ? (
                <span className="ms-0.5 text-danger" aria-hidden>
                    *
                </span>
            ) : null}
        </label>
        {description && !error ? (
            <p id={`${id}-desc`} className="text-xs text-neutral-secondary">
                {description}
            </p>
        ) : null}
        {children}
        {error ? (
            <p id={`${id}-error`} role="alert" className="text-xs text-danger">
                {error}
            </p>
        ) : null}
    </div>
);
